<template>
	<div class="index">
		<div class="overlay-menu">
			<div id="projets" class="tablecon">
				<div class="row th list">
					<div class="col-12 ta titlecont">Table of Contents</div>
				</div>
				<div id="table_content">
					<a @click="turnPage(12)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Adam Beach</div>
						<div class="hidden-xs col-sm-3">10</div>
					</a>
					<a @click="turnPage(22)" class="row list">
						<div class="col-xs-12 col-sm-9">Editor’s Letter</div>
						<div class="hidden-xs col-sm-3">20</div>
					</a>
					<a @click="turnPage(26)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Amanda Gorman</div>
						<div class="hidden-xs col-sm-3">24</div>
					</a>
					<a @click="turnPage(28)" class="row list">
						<div class="col-xs-12 col-sm-9">Masthead</div>
						<div class="hidden-xs col-sm-3">26</div>
					</a>
					<a @click="turnPage(30)" class="row list">
						<div class="col-xs-12 col-sm-9">Contributors</div>
						<div class="hidden-xs col-sm-3">28</div>
					</a>
					<a @click="turnPage(34)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Dr. Bernice King</div>
						<div class="hidden-xs col-sm-3">32</div>
					</a>
					<a @click="turnPage(36)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Abe Kim</div>
						<div class="hidden-xs col-sm-3">34</div>
					</a>
					<a @click="turnPage(40)" class="row list">
						<div class="col-xs-12 col-sm-9">Eco Edits</div>
						<div class="hidden-xs col-sm-3">38</div>
					</a>
					<a @click="turnPage(44)" class="row list">
						<div class="col-xs-12 col-sm-9">Where The Matrix Meets Fashion</div>
						<div class="hidden-xs col-sm-3">42</div>
					</a>
					<a @click="turnPage(52)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Billy Porter</div>
						<div class="hidden-xs col-sm-3">50</div>
					</a>
					<a @click="turnPage(54)" class="row list">
						<div class="col-xs-12 col-sm-9">Better Together</div>
						<div class="hidden-xs col-sm-3">52</div>
					</a>
					<a @click="turnPage(62)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Chris Paul </div>
						<div class="hidden-xs col-sm-3">60</div>
					</a>
					<a @click="turnPage(64)" class="row list">
						<div class="col-xs-12 col-sm-9">Walking Dead Stock</div>
						<div class="hidden-xs col-sm-3">62</div>
					</a>
					<a @click="turnPage(70)" class="row list">
						<div class="col-xs-12 col-sm-9">Diamonds For The Diaspora</div>
						<div class="hidden-xs col-sm-3">68</div>
					</a>
					<a @click="turnPage(78)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Dev Patel</div>
						<div class="hidden-xs col-sm-3">76</div>
					</a>
					<a @click="turnPage(80)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Alise Maxie</div>
						<div class="hidden-xs col-sm-3">78</div>
					</a>
					<a @click="turnPage(84)" class="row list">
						<div class="col-xs-12 col-sm-9">Democratizing Technology</div>
						<div class="hidden-xs col-sm-3">82</div>
					</a>
					<a @click="turnPage(92)" class="row list">
						<div class="col-xs-12 col-sm-9">The Music of Machines</div>
						<div class="hidden-xs col-sm-3">90</div>
					</a>
					<a @click="turnPage(98)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Alysa Monteagudo</div>
						<div class="hidden-xs col-sm-3">96</div>
					</a>
					<a @click="turnPage(102)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Erykah Badu</div>
						<div class="hidden-xs col-sm-3">100</div>
					</a>
					<a @click="turnPage(104)" class="row list">
						<div class="col-xs-12 col-sm-9">Math Rock Maven</div>
						<div class="hidden-xs col-sm-3">102</div>
					</a>
					<a @click="turnPage(110)" class="row list">
						<div class="col-xs-12 col-sm-9">Fighting for a Future</div>
						<div class="hidden-xs col-sm-3">108</div>
					</a>
					<a @click="turnPage(116)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Forest Whitaker</div>
						<div class="hidden-xs col-sm-3">114</div>
					</a>
					<a @click="turnPage(118)" class="row list">
						<div class="col-xs-12 col-sm-9">Native Brilliance Quannah Chasinghorse</div>
						<div class="hidden-xs col-sm-3">116</div>
					</a>
					<a @click="turnPage(124)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Archika Dogra</div>
						<div class="hidden-xs col-sm-3">122</div>
					</a>
					<a @click="turnPage(126)" class="row list">
						<div class="col-xs-12 col-sm-9">Rich Soil</div>
						<div class="hidden-xs col-sm-3">124</div>
					</a>
					<a @click="turnPage(136)" class="row list">
						<div class="col-xs-12 col-sm-9">Hungry for Change</div>
						<div class="hidden-xs col-sm-3">134</div>
					</a>
					<a @click="turnPage(142)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Hasan Minhaj</div>
						<div class="hidden-xs col-sm-3">140</div>
					</a>
					<a @click="turnPage(144)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Ashlyn So</div>
						<div class="hidden-xs col-sm-3">142</div>
					</a>
					<a @click="turnPage(146)" class="row list">
						<div class="col-xs-12 col-sm-9">From Korea to Cannes</div>
						<div class="hidden-xs col-sm-3">144</div>
					</a>
					<a @click="turnPage(154)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Jennifer Hudson</div>
						<div class="hidden-xs col-sm-3">152</div>
					</a>
					<a @click="turnPage(156)" class="row list">
						<div class="col-xs-12 col-sm-9">Acting with Empathy</div>
						<div class="hidden-xs col-sm-3">154</div>
					</a>
					<a @click="turnPage(170)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Di Binuya</div>
						<div class="hidden-xs col-sm-3">168</div>
					</a>
					<a @click="turnPage(174)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Kawennáhere Devery Jacobs</div>
						<div class="hidden-xs col-sm-3">172</div>
					</a>
					<a @click="turnPage(176)" class="row list">
						<div class="col-xs-12 col-sm-9">Black Is…</div>
						<div class="hidden-xs col-sm-3">174</div>
					</a>
					<a @click="turnPage(194)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Lin-Manuel Miranda</div>
						<div class="hidden-xs col-sm-3">192</div>
					</a>
					<a @click="turnPage(196)" class="row list">
						<div class="col-xs-12 col-sm-9">Impatient, Loud, and Joyful</div>
						<div class="hidden-xs col-sm-3">194</div>
					</a>
					<a @click="turnPage(202)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Dustin Vuong</div>
						<div class="hidden-xs col-sm-3">200</div>
					</a>
					<a @click="turnPage(204)" class="row list">
						<div class="col-xs-12 col-sm-9">Distorting Reality</div>
						<div class="hidden-xs col-sm-3">202</div>
					</a>
					<a @click="turnPage(212)" class="row list">
						<div class="col-xs-12 col-sm-9">The Future of Ballet is More Nuanced</div>
						<div class="hidden-xs col-sm-3">210</div>
					</a>
					<a @click="turnPage(218)" class="row list">
						<div class="col-xs-12 col-sm-9">The Face of a New Age of Cinema</div>
						<div class="hidden-xs col-sm-3">216</div>
					</a>
					<a @click="turnPage(224)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Michaela Coel</div>
						<div class="hidden-xs col-sm-3">222</div>
					</a>
					<a @click="turnPage(226)" class="row list">
						<div class="col-xs-12 col-sm-9">An Open Book</div>
						<div class="hidden-xs col-sm-3">224</div>
					</a>
					<a @click="turnPage(230)" class="row list">
						<div class="col-xs-12 col-sm-9">A Wise Old Rapper</div>
						<div class="hidden-xs col-sm-3">228</div>
					</a>
					<a @click="turnPage(236)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Nile Rodgers</div>
						<div class="hidden-xs col-sm-3">234</div>
					</a>
					<a @click="turnPage(238)" class="row list">
						<div class="col-xs-12 col-sm-9">The Community Artist</div>
						<div class="hidden-xs col-sm-3">236</div>
					</a>
					<a @click="turnPage(248)" class="row list">
						<div class="col-xs-12 col-sm-9">Rally for Peace</div>
						<div class="hidden-xs col-sm-3">246</div>
					</a>
					<a @click="turnPage(258)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Octavia Spencer</div>
						<div class="hidden-xs col-sm-3">256</div>
					</a>
					<a @click="turnPage(260)" class="row list">
						<div class="col-xs-12 col-sm-9">Star Struck</div>
						<div class="hidden-xs col-sm-3">258</div>
					</a>
					<a @click="turnPage(266)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Luke Chacko</div>
						<div class="hidden-xs col-sm-3">264</div>
					</a>
					<a @click="turnPage(270)" class="row list">
						<div class="col-xs-12 col-sm-9">Get on Board</div>
						<div class="hidden-xs col-sm-3">268</div>
					</a>
					<a @click="turnPage(278)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Padma Lakshmi</div>
						<div class="hidden-xs col-sm-3">276</div>
					</a>
					<a @click="turnPage(280)" class="row list">
						<div class="col-xs-12 col-sm-9">A Proposal for Change</div>
						<div class="hidden-xs col-sm-3">278</div>
					</a>
					<a @click="turnPage(286)" class="row list">
						<div class="col-xs-12 col-sm-9">Reflections on Afghan Women</div>
						<div class="hidden-xs col-sm-3">284</div>
					</a>
					<a @click="turnPage(292)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Nico Craig</div>
						<div class="hidden-xs col-sm-3">290</div>
					</a>
					<a @click="turnPage(294)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Q’orianka Kilcher</div>
						<div class="hidden-xs col-sm-3">292</div>
					</a>
					<a @click="turnPage(296)" class="row list">
						<div class="col-xs-12 col-sm-9">Fashion–The Young Ones</div>
						<div class="hidden-xs col-sm-3">294</div>
					</a>
					<a @click="turnPage(312)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Riz Ahmed</div>
						<div class="hidden-xs col-sm-3">310</div>
					</a>
					<a @click="turnPage(314)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Sam Schimmel</div>
						<div class="hidden-xs col-sm-3">312</div>
					</a>
					<a @click="turnPage(316)" class="row list">
						<div class="col-xs-12 col-sm-9">Fashion – Candid Camera</div>
						<div class="hidden-xs col-sm-3">314</div>
					</a>
					<a @click="turnPage(326)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Sean Combs</div>
						<div class="hidden-xs col-sm-3">324</div>
					</a>
					<a @click="turnPage(328)" class="row list">
						<div class="col-xs-12 col-sm-9">Understanding the Attack on Critical Race Theory</div>
						<div class="hidden-xs col-sm-3">326</div>
					</a>
					<a @click="turnPage(334)" class="row list">
						<div class="col-xs-12 col-sm-9">Council Woman or Wonder Woman?</div>
						<div class="hidden-xs col-sm-3">332</div>
					</a>
					<a @click="turnPage(340)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Stacey Abrams</div>
						<div class="hidden-xs col-sm-3">338</div>
					</a>
					<a @click="turnPage(342)" class="row list">
						<div class="col-xs-12 col-sm-9">A Call to Action</div>
						<div class="hidden-xs col-sm-3">340</div>
					</a>
					<a @click="turnPage(348)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Sophia Kianni</div>
						<div class="hidden-xs col-sm-3">346</div>
					</a>
					<a @click="turnPage(350)" class="row list">
						<div class="col-xs-12 col-sm-9">Seeing Yusef Salaam</div>
						<div class="hidden-xs col-sm-3">348</div>
					</a>
					<a @click="turnPage(358)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Trevor Noah</div>
						<div class="hidden-xs col-sm-3">356</div>
					</a>
					<a @click="turnPage(360)" class="row list">
						<div class="col-xs-12 col-sm-9">Fashion- We’re the Kids in America</div>
						<div class="hidden-xs col-sm-3">358</div>
					</a>
					<a @click="turnPage(388)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Udonis Haslem</div>
						<div class="hidden-xs col-sm-3">386</div>
					</a>
					<a @click="turnPage(390)" class="row list">
						<div class="col-xs-12 col-sm-9">Fashion - High Barnet</div>
						<div class="hidden-xs col-sm-3">388</div>
					</a>
					<a @click="turnPage(410)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Viola Davis</div>
						<div class="hidden-xs col-sm-3">408</div>
					</a>
					<a @click="turnPage(412)" class="row list">
						<div class="col-xs-12 col-sm-9">Fashion: An Ode to Patrick Kelly</div>
						<div class="hidden-xs col-sm-3">410</div>
					</a>
					<a @click="turnPage(434)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Waris Ahluwalia</div>
						<div class="hidden-xs col-sm-3">432</div>
					</a>
					<a @click="turnPage(436)" class="row list">
						<div class="col-xs-12 col-sm-9">YOUTH SERIES: Zoe Hana Mikuta</div>
						<div class="hidden-xs col-sm-3">434</div>
					</a>
					<a @click="turnPage(438)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Yusra Mardini</div>
						<div class="hidden-xs col-sm-3">436</div>
					</a>
					<a @click="turnPage(440)" class="row list">
						<div class="col-xs-12 col-sm-9">Stockists</div>
						<div class="hidden-xs col-sm-3">438</div>
					</a>
					<a @click="turnPage(442)" class="row list">
						<div class="col-xs-12 col-sm-9">#BIPOCissue - Zazie Beets</div>
						<div class="hidden-xs col-sm-3">440</div>
					</a>
					<a @click="turnPage(444)" class="row list">
						<div class="col-xs-12 col-sm-9">Code of Ethics</div>
						<div class="hidden-xs col-sm-3">442</div>
					</a>
					<a @click="turnPage(445)" class="row list">
						<div class="col-xs-12 col-sm-9">Next Issue</div>
						<div class="hidden-xs col-sm-3">443</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
import "@/lib/turn.min.js";
import { mapMutations } from "vuex";

export default {
	methods: {
		turnPage(num) {
			$(".flipbook").turn("page", num);
			this.setClass(false);
		},
		...mapMutations("magazine", ["setClass"]),
	},
};
</script>

<style lang="scss">
.overlay-menu {
	position: absolute;
	background: white;
	width: 100%;
	height: 100%;
	z-index: 999;
	overflow-x: hidden;
	overflow-y: scroll;
	top: 0px;
}

#projets .th.row.list div:last-child,
#projets a.row.list div:last-child {
	text-align: right;
	font-family: "CaslonOldFace";
}

#projets .row.list div:first-child {
	display: inline;
	font-family: "CaslonOldFace";
}

#projets .row.th div {
	font-weight: 600;
	color: rgba(10, 0, 30, 0.26);
	text-transform: uppercase;
	font-size: 0.8em;
	letter-spacing: 0.1em;
	margin-left: -10%;
}

#projets .row.list div {
	font-size: 1.2em;
	padding-top: 0.6em;
	padding-bottom: 0.6em;
	font-weight: 200;
	line-height: 0.6em;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	margin: 0;
}

.tablecon {
	padding-left: 25%;
	padding-right: 25%;
	padding-top: 10%;
	padding-bottom: 10%;

	a {
		text-decoration: none;
		color: black;
		opacity: 0.5;
		cursor: pointer;
	}

	a:hover {
		color: black;
		font-weight: 900;
		opacity: 5;
		font-size: 1.2em;
	}
}

.titlecont {
	font-size: x-large !important;
	padding-bottom: 75px !important;
	text-align: center !important;
}
</style>
